<template>
  <div>
    <Header></Header>
    <section>
      <div class="page_map">
        <ol class="breadcrumb">
          <li><router-link to="/">Home</router-link></li>
        </ol>
      </div>
      <div class="index_table">
        <table>
          <thead>
            <tr>
              <th>{{ $t("probe.ProbeID") }}</th>
              <th>{{ $t("probe.TargetProteins") }}</th>
              <th>{{ $t("probe.species") }}</th>
              <th>{{ $t("probe.ProteinDescription") }}</th>
              <th>{{ $t("probe.GeneName") }}</th>
              <th>{{ $t("probe.LabeledSitesDetail") }}</th>
              <th>{{ $t("probe.Concentration") }}</th>
              <th>{{ $t("probe.ratio") }}</th>
              <th>{{ $t("probe.competitiveligand") }}</th>
              <th>{{ $t("probe.cellline") }}</th>
              <th width="180">{{ $t("probe.datasource") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, key) in list" :for="key" :style="setstyle(v)">
              <td>{{ v.ProbeId }}<br><img :src='v.ProbeStructImg && v.ProbeStructImg.val ? v.ProbeStructImg.val.url : ""'>
              </td>
              <td>{{ v.ProteinId }}</td>
              <td>{{ v.Species }}</td>
              <td>{{ v.ProteinDescription }}</td>
              <td>{{ v.GeneNames }}</td>
              <td>
                <!--<router-link :to="{ path: '/site', query: { LDDBid: v.LDDBid, ProbeId: v.ProbeId } }" target="_blank">Link
                </router-link>-->
                <a  href="javascript:void(0)" v-if='showwd(v.SitesList)'
                    @click="linkactive(v.LDDBid, v.Source, v.ProbeId,v.ProteinId)">Link</a>
              </td>
              <td>
                <div v-html="resetVal(v.Density)"></div>
              </td>
              <td>
                <div v-html="resetVal(v.CompetitiveRatio)"></div>
              </td>
              <td>
                <!--<router-link v-if="(val!='-')" :to="'/competition?LigandId=' + val" target="_blank" v-for="(val, key1) in v.LigandId"
                  :key="key">
                  {{ val }}
                </router-link>-->
                  <a v-if="(val!='-')" href="javascript:void(0)" v-for="(val, key1) in v.LigandId" @click="showLigandId(val)">
                    {{ val }}
                  </a>
              </td>
              <td>
                <div v-html="resetXBVal(v.CellLine)"></div>
              </td>
              <td>
                <div v-for="(val, key1) in v.Source" :key="key1">
                  <a href="javascript:void(0)" @click="sourcesOpen(val)">{{ val }}</a>
                  <!--<br v-if="key1!=v.Source.length-1">-->
                </div>
              </td>
            </tr>

          </tbody>
        </table>
        <div class="pagediv">
          <ul class="pagination">
            <li :class="page.pageNum <= 1 ? 'disabled' : ''" class="page-item" @click="prePage()"><a href="#">&laquo;</a>
            </li>
            <li :class="page.pageNum === index ? 'page-link active' : ''" v-for="index in pageTotal"
              @click="curPage(index)"
              v-show="(index == 1 || pageTotal == index || (index >= page.pageNum && index <= page.pageNum + 4))">
              <a href="#" v-if="(index == page.pageNum && index != 1)"
                style=" color: #337ab7;background-color: #fff;border: 1px solid #ddd;"
                @click.stop="curPage(page.pageNum - 1)">...</a>
              <a href="#">{{ index }}</a>
              <a href="#" v-if="index == (page.pageNum + 4) && pageTotal != index"
                @click.stop="curPage(page.pageNum + 1)">...</a>
            </li>
            <li :class="page.pageNum >= pageTotal ? 'disabled' : ''" class="page-item" @click="nextPage()"><a
                href="#">&raquo;</a></li>
            <li>
              <span>前往</span><input type="text" class="page_input" v-model="inputpage" @change="setpage()"><span>页</span>
            </li>
          </ul>
        </div>
      </div>

    </section>

    <div class="pop_bg" v-show="popBgShow == true"></div>
    <div class="pop_apply_box" v-show="popShow == true">
      <div class="header_info">
        <div class="title">竞争本体申请</div>
        <a href="javascript:void(0)" class="close_btn" @click="applyClose()">×</a>
      </div>
      <form>
        <dl class="formcolumn-item ">
          <dt class="formcolumn-item-tit">名称：</dt>
          <dd class="formcolumn-item-ct">
            <input type="text" placeholder="admin" />
          </dd>
        </dl>
        <dl class="formcolumn-item ">
          <dt class="formcolumn-item-tit">联系方式：</dt>
          <dd class="formcolumn-item-ct">
            <input type="text" placeholder="admin" />
          </dd>
        </dl>
        <dl class="formcolumn-item ">
          <dt class="formcolumn-item-tit">身份：</dt>
          <dd class="formcolumn-item-ct">
            <input type="text" placeholder="admin" />
          </dd>
        </dl>
        <div class="footer_btn">
          <input type="button" id="ORDERPOST" value="立即申请">
        </div>
      </form>

    </div>
    <div class="pop_data_sources" v-show="popSourcesShow == true">
      <div class="header_info">
        <div class="title">数据来源{{ syData.datacode }}</div>
        <a href="javascript:void(0)" class="close_btn" @click="sourcesClose()">×</a>
      </div>
      <h1>内容：</h1>
      <div class="sources_article">
        实验编号： {{ syData.experimentnumber }}<br>
        实验日期：{{ syData.implementationdate ? syData.implementationdate : "" }}<br>
        实验设计（模板）：<div v-html="syData.designexperiments"></div>
      </div>
    </div>
    <div class="pop_data_sources" v-show="popLigandShow">
      <div class="header_info">
        <div class="title">竞争配体名称：{{ LigandInf.name }}</div>
        <a href="javascript:void(0)" class="close_btn" @click="sourcesClose()">×</a>
      </div>
      <h1>内容：</h1>
      <div class="sources_article">
        其他名称： {{ LigandInf.OtherName }}<br>
        分子量：{{ LigandInf.MolecularWeight ? LigandInf.MolecularWeight : "" }}<br>
        结构图：
        <div v-html="setlisrc(LigandInf.ProbeStructurePic)" ></div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from './header/Index.vue'
import Footer from './footer/Index.vue'
import api from './../axios/api.js'
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      popBgShow: false,
      popShow: false,
      popSourcesShow: false,
      list: [],
      syData: {},
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      pageTotal: 0,
      total: 0, // 当前条数
      param: {},
      isarticle: false,
      inputpage: "",
      popLigandShow: false,
      LigandInf: {},
    }
  },
  mounted() {
    this.getdetailData()
  },
  methods: {
    async showLigandId(val) {
      var that = this;
      var postdata = {
        "LigandId": val
      };
      var urllist = "/action/ebyeghlrgjlqpdlfr/getdata";
      api.getTableData(urllist, JSON.stringify(postdata)).then(res => {
        if (res.data && res.data.rows.length > 0) {
          that.LigandInf = res.data.rows[0];
          that.popLigandShow = true;
        }
      });
    },
    setlisrc(val) {
      var lihtml = "";
      if (val && val.val && val.val.url) lihtml = "<img src='" + val.val.url + "' alt='' height='200'>"
      return lihtml;
    },
    showwd(SitesList) {
      if (SitesList && SitesList.length > 0) {
        var isshow = false;
        SitesList.forEach(function (val) {
          if (val) {
            isshow = true;
          }
        })
        return isshow;
      }
    },
    linkactive(LDDBid, Source, ProbeId,ProteinId) {
      var that=this;
      var isl = localStorage.getItem("isLogined");
      var un= localStorage.getItem("username");
      let urllist = '/action/ejatglkvakzowpjax/linp';
      var yzform={
            username:un,
            isl:isl
        };
      api.getTableData(urllist, JSON.stringify(yzform)).then(res => {
        if (res.result == 1) {
          if(res.message=="无Link访问权限"){
            that.showInfo('无Link访问权限');
          }
        }else{
          if (Source[0].indexOf('LDRA') != -1) {
            that.$router.push({ path: '/site', query: { LDDBid: LDDBid, ProbeId: ProbeId,ProteinId:ProteinId } });
          } else {
            var isLogined = localStorage.getItem("isLogined");
            if (!isLogined) {
              that.showInfo('该功能仅限高级会员使用，请登录或联系我们');
              return
            }
            that.$router.push({ path: '/site', query: { LDDBid: LDDBid, ProbeId: ProbeId,ProteinId:ProteinId } });
          }
        }
      })

    },
    resetXBVal(val) {
      let newval = "";
      if (val == undefined) {
        return newval;
      }
      val.forEach(function (item) {
        var nval = "";
        if (item) {
          if (item.indexOf('LDCLL') != -1) {
            item = item.replace('LDCLL', '');
          }
          if (item.indexOf('LDCLC') != -1) {
            item = item.replace('LDCLC', '');
          }
          if (item.indexOf('LDCL') != -1) {
            item = item.replace('LDCL', '');
          }
          nval = item;
        }
        newval += nval + "<br>";
      })
      return newval;
    },
    setstyle(val) {
      if (val.vindex % 2 == 0) {
        return "background: #fff;";
      }
      return "background: #f4f7fb;";
    },
    setpage() {
      if (this.inputpage) {
        this.page.pageNum = parseInt(this.inputpage);
        this.getPatients(this.page.pageNum);
        this.inputpage = "";
      }
    },
    curPage(index) {
      this.getPatients(index);
    },
    prePage() {
      if (this.page.pageNum > 1) {
        this.getPatients(--this.page.pageNum);
      }
    },
    nextPage() {
      if (this.page.pageNum < this.pageTotal) {
        this.getPatients(++this.page.pageNum);
      }
    },
    getPatients(pageNum) {
      this.page.pageNum = pageNum;
      this.getdetailData();
    },
    resetVal(val) {
      let newval = "";
      if (val == undefined || !val || val == 'null') {
        return newval;
      }
      val.forEach(function (item) {
        var nval = "";
        if (item) {
          nval = item;
        }
        newval += nval + "<br>";
      })
      return newval;
    },
    setSourceValue(item, value) {
      return value;
      var rethtml = '';
      if (value == 0) {
        //文献
        if (item.References != null && item.References.lenght != 0) {
          for (var i = 0; i < item.References.length; i++) {
            if (rethtml.length > 0) {
              rethtml += "<br/>";
            }
            var url = item.References[i]["Url"];
            if (url != null && url != '') {
              rethtml += '<a href="' + url + '" target="_blank">' + item.References[i].No + '</a>';
            } else {
              rethtml += item.References[i].No;
            }
          }
        }
      } else {
        //实验记录
        rethtml = item.RecordNo;
      }
      return rethtml;
    },
    applyOpen() {
      this.popBgShow = true;
      this.popShow = true;
    },
    applyClose() {
      this.popBgShow = false;
      this.popShow = false;
    },
    sourcesOpen(val) {
      this.getdsjyData(val);
      if (!this.isarticle) {
        this.popBgShow = true;
        this.popSourcesShow = true;
      }
    },
    sourcesClose() {
      this.popBgShow = false;
      this.popSourcesShow = false;
      this.popLigandShow = false;
    },
    async getdsjyData(val) {
      //查询数据源
      var that = this;
      var postdata = {
        "datacode": val
      };
      that.isarticle = false;
      let urllist = '/action/egxqivukrqpdlzsjz/getdata';
      if (val.indexOf('LDRA') != -1) {
        urllist = "/action/exettxhpoqalqpzer/getdata";
        postdata = {
          "articleid": val
        };
        that.isarticle = true;
      }

      await api.getTableData(urllist, JSON.stringify(postdata)).then(res => {
        if (res.data && res.data.rows.length > 0) {
          that.syData = res.data.rows[0];
          if (that.isarticle) {
            window.open(that.syData.essayurl);
          }
        }
      });
    },
    async getdetailData() {
      //查询详情
      var that = this;
      var ProbeId = this.$route.query.pid;
      var param = {};
      param.page = that.page;
      param.total = that.total;
      param.totalPages = that.pageTotal;
      param.ProbeId = ProbeId
      param = JSON.stringify(param);
      let urllist = '/action/etpdxwptrnxiwushd/probedata';
      that.list = [];
      await api.getTableData(urllist, param).then(res => {
        if (res.data) {
          if (that.page.pageNum == 1) {
            that.pageTotal = res.data.param.totalPages;
            that.total = res.data.param.total;
          }
          res.data.rows.forEach(function (v, index) {
            var lists = v;
            lists.ProbeId.forEach(function (val, ind) {
              if (val == ProbeId) {
                var onelist = JSON.parse(JSON.stringify(v));
                onelist["ProbeStructImg"] = v["ProbeStructImg"][ind];
                onelist["ProbeType"] = v["ProbeType"][ind];
                onelist['Density'] = lists['Density'][val];
                onelist['concentration'] = lists['concentration'][val];
                onelist['CompetitiveRatio'] = lists['CompetitiveRatio'][val];
                onelist['LigandId'] = lists['LigandId'][val];
                onelist['CellLine'] = lists['CellLine'][val];
                onelist['Source'] = lists['Source'][val];
                onelist['SitesList'] = lists['SitesList'][val];
                onelist['ProbeId'] = val;
                onelist['vindex'] = index;
                that.list.push(onelist);
              }
            });
          })
        }
      });
    },
    showInfo(val) {
      toastr.info(val, this.$t('indexwarn.downwarntitle'), {
        closeButton: true,
        progressBar: true,
        newestOnTop: true,
        positionClass: "toast-top-center"
      });
      return;
    }
  }
}
</script>
<style scoped>
.page_input {
  position: relative;
  float: left;
  padding: 5px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #337ab7;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
  width: 40px;
}
</style>


// WEBPACK FOOTER //
// src/views/Probe.vue